import { GroupNames, GroupName } from "../../utils/group-names";

/**
 * Configuration interface for group-based access control
 */
export interface IGroupAccessConfig {
  /**
   * Groups required for access to a resource
   */
  requiredGroups?: GroupName[];

  /**
   * If true, user must be in ALL specified groups
   * If false, user must be in ANY of the specified groups
   * Default: false
   */
  requireAllGroups?: boolean;
}

/**
 * Utility class for creating group access configurations
 */
export class GroupAccessConfig {
  /**
   * Creates configuration requiring user to be in ANY of the specified groups
   */
  static requireAnyGroup(...groups: GroupName[]): IGroupAccessConfig {
    return {
      requiredGroups: groups,
      requireAllGroups: false,
    };
  }

  /**
   * Creates configuration requiring user to be in ALL of the specified groups
   */
  static requireAllGroups(...groups: GroupName[]): IGroupAccessConfig {
    return {
      requiredGroups: groups,
      requireAllGroups: true,
    };
  }

  /**
   * Creates configuration for turbine users
   */
  static turbineUsers(): IGroupAccessConfig {
    return this.requireAnyGroup(GroupNames.TURBINE_USERS);
  }

  /**
   * Creates configuration for RAM planners
   */
  static ramPlanners(): IGroupAccessConfig {
    return this.requireAnyGroup(GroupNames.RAM_PLANNERS);
  }

  /**
   * Creates configuration for technical letter viewers (viewers or admins)
   */
  static technicalLetterViewers(): IGroupAccessConfig {
    return this.requireAnyGroup(
      GroupNames.TECHNICAL_LETTER_VIEWERS,
      GroupNames.TECHNICAL_LETTER_ADMINS
    );
  }

  /**
   * Creates configuration for technical letter admins only
   */
  static technicalLetterAdmins(): IGroupAccessConfig {
    return this.requireAnyGroup(GroupNames.TECHNICAL_LETTER_ADMINS);
  }
}
